import { ToggleGroup, ToggleGroupItem } from '@/components'
import { useTranslate } from '@ur-solutions/react-hooks'

const LOCK_ACTIONS = [
  { value: 'create', bit: 1 },
  { value: 'update', bit: 2 },
  { value: 'delete', bit: 4 },
] as const

type LockActionValue = (typeof LOCK_ACTIONS)[number]['value']

function getSelectedActions(mask: number): LockActionValue[] {
  return LOCK_ACTIONS.filter(action => (mask & action.bit) !== 0).map(
    action => action.value
  )
}

function getMaskFromActions(actions: LockActionValue[]): number {
  return actions.reduce((mask, action) => {
    const bit = LOCK_ACTIONS.find(option => option.value === action)?.bit ?? 0
    return mask | bit
  }, 0)
}

interface LockActionsToggleProps {
  className?: string
  itemClassName?: string

  value: number
  onChange(value: number): void
}

export function LockActionsToggle({
  className,
  itemClassName,

  value,

  onChange,
}: LockActionsToggleProps) {
  const translations = useTranslate({
    create: 'common.create',
    update: 'common.update',
    delete: 'common.delete',
  })

  const selected = getSelectedActions(value)

  function handleChange(values: string[]) {
    onChange(getMaskFromActions(values as LockActionValue[]))
  }

  return (
    <ToggleGroup
      className={className}
      type="multiple"
      variant="outline"
      value={selected}
      onValueChange={handleChange}
    >
      <ToggleGroupItem className={itemClassName} value="create">
        <span className="translate-y-px">{translations.create}</span>
      </ToggleGroupItem>

      <ToggleGroupItem className={itemClassName} value="update">
        <span className="translate-y-px">{translations.update}</span>
      </ToggleGroupItem>

      <ToggleGroupItem className={itemClassName} value="delete">
        <span className="translate-y-px">{translations.delete}</span>
      </ToggleGroupItem>
    </ToggleGroup>
  )
}
